'use client'

import { ColumnDef } from '@tanstack/react-table'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Eye, Edit } from 'lucide-react'

// import { labels, priorities, statuses } from "../data/data";
import { DataTableColumnHeader } from '../../../components/shared/data-table/data-table-column-header'

export const columns = [
  {
    accessorKey: 'id',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Id" />
    ),
    cell: ({ row }) => (
      <div className="text-xs text-muted-foreground">{row.getValue('id')}</div>
    ),
    enableSorting: false,
    enableHiding: true,
    meta: { width: '50px' },
  },
  {
    accessorKey: 'image',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Image" />
    ),
    cell: ({ row }) => {
      const imageUrl = row.getValue('image')
      if (!imageUrl) return null
      return (
        <div className="w-16 h-16">
          <img
            src={imageUrl}
            alt="Product"
            className="w-full h-full object-cover rounded-sm"
          />
        </div>
      )
    },
    enableSorting: false,
    enableHiding: true,
    meta: { width: '80px' },
  },
  {
    accessorKey: 'name',
    id: 'name',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    enableSorting: false,
    enableHiding: true,

    cell: ({ row }) => {
      const navigate = useNavigate()
      return (
        <div
          data-testid="product-link"
          className="flex items-center space-x-4 cursor-pointer"
          onClick={() => navigate(`/products/${row.original.id}`)}
        >
          <span className="max-w-[400px] truncate font-medium">
            {row.getValue('name')}
          </span>
        </div>
      )
    },
  },
  {
    accessorKey: 'visible',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Visible" />
    ),
    cell: ({ row }) => {
      const isVisible = row.getValue('visible')
      return (
        <Badge variant={isVisible ? 'green' : 'secondary'}>
          {isVisible ? 'Visible' : 'Hidden'}
        </Badge>
      )
    },
    enableSorting: false,
    enableHiding: true,
    meta: { width: '90px' },
  },
]
